/*! @pentacode/ui v0.1.0 */
import { noChange as e } from "lit";
import { AsyncDirective as t, directive as n } from "lit/async-directive.js";
import { PartType as r } from "lit/directive.js";
var i = n(class extends t {
	constructor(e) {
		if (super(e), this._element = null, this._options = {}, this._offset = {
			x: 0,
			y: 0
		}, this._startPos = {
			x: 0,
			y: 0
		}, this._moved = !1, this._isDragging = !1, this._pointerId = null, this._onPointerDown = (e) => {
			if (!e.isPrimary || (this._isDragging && (this._releasePointer(), this._isDragging = !1, this._moved = !1), e.target.closest("button, a, input, select, textarea, [role='button'], [contenteditable]"))) return;
			e.preventDefault(), this._element?.setPointerCapture(e.pointerId), this._pointerId = e.pointerId, this._startPos = {
				x: e.clientX,
				y: e.clientY
			}, this._moved = !1, this._offset = this._calculatePointerOffset(e);
			let t = this._getTarget();
			this._element?.classList.add("grabbing"), this._element?.setAttribute("dragging", ""), t !== this._element && (t.classList.add("grabbing"), t.setAttribute("dragging", "")), globalThis.addEventListener("pointermove", this._onPointerMove, { passive: !0 }), globalThis.addEventListener("pointerup", this._onPointerUp), globalThis.addEventListener("pointercancel", this._onPointerCancel);
		}, this._onPointerMove = (e) => {
			if (this._pointerId !== null && e.pointerId !== this._pointerId) return;
			let t = this._options.threshold ?? 0;
			if (!this._moved) {
				let n = e.clientX - this._startPos.x, r = e.clientY - this._startPos.y;
				if (Math.sqrt(n * n + r * r) <= t) return;
				this._moved = !0, this._isDragging = !0, this._options.onStart?.();
			}
			let n = e.clientX - this._offset.x, r = e.clientY - this._offset.y, i = this._getTarget(), a = this._options.xProperty ?? "--x", o = this._options.yProperty ?? "--y";
			i.style.setProperty(a, `${n}px`), i.style.setProperty(o, `${r}px`), this._options.onMove?.(n, r);
		}, this._onPointerUp = (e) => {
			if (this._pointerId !== null && e.pointerId !== this._pointerId) return;
			this._releasePointer();
			let t = this._getTarget();
			this._element?.classList.remove("grabbing"), this._element?.removeAttribute("dragging"), t !== this._element && (t.classList.remove("grabbing"), t.removeAttribute("dragging"));
			let n = this._moved;
			this._moved = !1, this._isDragging = !1, this._options.onEnd?.(n);
		}, this._onPointerCancel = (e) => {
			if (this._pointerId !== null && e.pointerId !== this._pointerId) return;
			this._releasePointer();
			let t = this._getTarget();
			this._element?.classList.remove("grabbing"), this._element?.removeAttribute("dragging"), t !== this._element && (t.classList.remove("grabbing"), t.removeAttribute("dragging")), this._moved = !1, this._isDragging = !1, this._options.onEnd?.(!1);
		}, e.type !== r.ELEMENT) throw Error("movable directive must be used on an element");
	}
	render(t) {
		return e;
	}
	update(t, [n]) {
		return this._options = n ?? {}, this._element !== t.element && (this._cleanup(), this._element = t.element, this._element.addEventListener("pointerdown", this._onPointerDown), this._element.style.touchAction = "none"), e;
	}
	_getTarget() {
		return this._options.target ?? this._element;
	}
	_calculatePointerOffset(e) {
		let { left: t, width: n, top: r, height: i } = this._getTarget().getBoundingClientRect();
		return {
			x: e.clientX - (t + n / 2),
			y: e.clientY - (r + i / 2)
		};
	}
	_releasePointer() {
		globalThis.removeEventListener("pointermove", this._onPointerMove), globalThis.removeEventListener("pointerup", this._onPointerUp), globalThis.removeEventListener("pointercancel", this._onPointerCancel), this._pointerId !== null && this._element && (this._element.releasePointerCapture(this._pointerId), this._pointerId = null);
	}
	_cleanup() {
		if (this._element) {
			this._element.removeEventListener("pointerdown", this._onPointerDown), this._element.style.touchAction = "";
			let e = this._getTarget();
			this._element.classList.remove("grabbing"), this._element.removeAttribute("dragging"), e !== this._element && (e.classList.remove("grabbing"), e.removeAttribute("dragging"));
		}
		this._releasePointer(), this._isDragging = !1, this._moved = !1;
	}
	disconnected() {
		this._cleanup();
	}
	reconnected() {
		this._element && this._element.addEventListener("pointerdown", this._onPointerDown);
	}
});
export { i as movable };

//# sourceMappingURL=movable.js.map